import Route from '@core/components/Route';
import { RoutePath } from '@core/types/route';
import { ReactElement } from 'react';

export const FALKO_ZANDER_MASTERS: ReactElement[] = [
  <>
    Großmeister <Route href={RoutePath.AlexanderSolovev}>Alexander Solovev</Route> (Russland),
    <br />
    Gründer von Solovev Style
  </>,
  <>
    Großmeister Mikhail Ryabko (Russland)
    <br />
    Gründer von Systema Ryabko
  </>,
  <>
    Großmeister Prof. Dr. sc. Keith R. Kernspecht (Deutschland)
    <br />
    Leiter und Gründer der Europäischen WingTsun Organisation
  </>,
  <>
    Großmeister Manfred Steiner (Deutschland)
    <br />
    Chinese Boxing und Heilkunst
  </>,
  <>
    Yuri Burlan (USA)
    <br />
    Vektor-Psychologie Burlan
  </>,
  <>
    Meister Alexander Andreychenkov (Russland)
    <br />
    Systema Ryabko
  </>,
  <>
    Meister Vladimir Vasiliev (Kanada)
    <br />
    Systema Ryabko
  </>,
  <>
    Meister Valentin Talanov (Russland)
    <br />
    Systema Talanov
  </>,
  <>
    Meister Sergey Borshov (Russland)
    <br />
    Systema Ryabko
  </>,
  <>
    Meister Wolfgang Reitsch (Deutschland)
    <br />
    5. Dan Ju-Jutsu
  </>,
  <>
    Daniil Ryabko (Russland)
    <br />
    Systema Ryabko
  </>,
  <>
    Andreas Weitzel (Deutschland)
    <br />
    Systema Ryabko
  </>,
];
